import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import SurveyInviteForm from '../../../components/forms/SurveyInviteForm';
import { useSurveyInviteById, useUpdateSurveyInvite } from '../../../hooks/useSurveyInviteApi';
import { useNavigate, useParams } from 'react-router-dom';

const SurveyInviteEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useSurveyInviteById(id!);
  const updateSurveyInvite = useUpdateSurveyInvite();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Survey Invites', href: '/admin/surveyinvites' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateSurveyInvite.mutateAsync({ id: id!, data });
      navigate('/admin/surveyinvites');
    } catch (error) {
      console.error('Error updating SurveyInvite:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/surveyinvites"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.SurveyInvite.Edit'
    >
      {entityData ? (
        <SurveyInviteForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/surveyinvites')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default SurveyInviteEdit;
